import { object, optional, string } from 'superstruct';

export const chatHistoryConfigSchema = object({
  backButtonFallbackUrl: optional(string()),
});
